import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

function SpecialPermitUpdateFeesModal({
  updateFees,
  formData,
  setFormData,
  transactionId,
  submitting,
  showTransaction,
  data
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    surcharge: 'required',
    penalty: 'required',
    other_fee: 'required',
  });

  const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, '');

  const handleOnSubmit = e => {
    e.preventDefault();

    updateFees(transactionId, formData, () => {
      setModal({ isOpen: false });
      showTransaction(transactionId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const OnSetFormData = () => {
    setFormData({
      surcharge: data.attributes.surcharge || 0,
      penalty: data.attributes.penalty || 0,
      other_fee: data.attributes.other_fee || 0,
    });
  };


  useEffect(() => {
    if (!_.isEmpty(data)) {
      OnSetFormData();
    }
  }, []);

  const handleChangeSurcharge = event =>
    setFormData({
      surcharge: addCommas(removeNonNumeric(event.target.value)),
    });

  const handleChangePenalty = event =>
    setFormData({
      penalty: addCommas(removeNonNumeric(event.target.value)),
    });

  const handleChangeOtherFee = event =>
    setFormData({
      other_fee: addCommas(removeNonNumeric(event.target.value)),
    });

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Surcharge {validateForm.renderMessage('surcharge')}
            </label>
            <input
              className="form-control"
              type="text"
              name="surcharge"
              onChange={handleChangeSurcharge}
              value={_.get(formData, 'surcharge') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Penalty {validateForm.renderMessage('penalty')}
            </label>
            <input
              className="form-control"
              type="text"
              name="penalty"
              onChange={handleChangePenalty}
              value={_.get(formData, 'penalty') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Other Fee {validateForm.renderMessage('other_fee')}
            </label>
            <input
              className="form-control"
              type="text"
              name="other_fee"
              onChange={handleChangeOtherFee}
              value={_.get(formData, 'other_fee') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={submitting}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-cancel"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={submitting}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary ml-3"
          >
            <span className="font-weight-bold">
              {submitting ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

SpecialPermitUpdateFeesModal.defaultProps = {
  data: {},
}

SpecialPermitUpdateFeesModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateFees: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionId: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  data: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  submitting: api.loading.indexOf(c.SUBMIT_ASSESSMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SpecialPermitUpdateFeesModal);
